// extracted by css-extract-rspack-plugin
export default {"ticketId":"Bas19Il6w7dla5xn"};